/* Car Delivery - This line cannot be edited or removed */
export const GET_CAR_DELIVERIES = "GET_CAR_DELIVERIES"
export const GET_CAR_DELIVERIES_SUCCESS = "GET_CAR_DELIVERIES_SUCCESS"
export const GET_CAR_DELIVERIES_FAIL = "GET_CAR_DELIVERIES_FAIL"

/* Car Delivery DETAILS */
export const GET_CAR_DELIVERY_DETAILS = "GET_CAR_DELIVERY_DETAILS"
export const GET_CAR_DELIVERY_DETAILS_SUCCESS = "GET_CAR_DELIVERY_DETAILS_SUCCESS"
export const GET_CAR_DELIVERY_DETAILS_FAIL = "GET_CAR_DELIVERY_DETAILS_FAIL"

/* CREATE Car Delivery */
export const CREATE_CAR_DELIVERY = "CREATE_CAR_DELIVERY"
export const CREATE_CAR_DELIVERY_SUCCESS = "CREATE_CAR_DELIVERY_SUCCESS"
export const CREATE_CAR_DELIVERY_FAIL = "CREATE_CAR_DELIVERY_FAIL"

/* Edit Car Delivery */
export const UPDATE_CAR_DELIVERY = "UPDATE_CAR_DELIVERY"
export const UPDATE_CAR_DELIVERY_SUCCESS = "UPDATE_CAR_DELIVERY_SUCCESS"
export const UPDATE_CAR_DELIVERY_FAIL = "UPDATE_CAR_DELIVERY_FAIL"

/* Delete Car Delivery */
export const DELETE_CAR_DELIVERY = "DELETE_CAR_DELIVERY"
export const DELETE_CAR_DELIVERY_SUCCESS = "DELETE_CAR_DELIVERY_SUCCESS"
export const DELETE_CAR_DELIVERY_FAIL = "DELETE_CAR_DELIVERY_FAIL"

